/**
 * Returns the dot product of two 1-D arrays
 */
export function dotProduct(a: number[], b: number[]): number {
    let prod = 0;
    for (let i = 0; i < a.length; i++) {
        prod += a[i] * b[i];
    }
    return prod;
}

/**
 * Returns the magnitude of a vector, where the vector is represented as an array
 */
export function magnitude(a: number[]): number {
    let sum = 0;
    for (let i = 0; i < a.length; i++) {
        sum += a[i] * a[i];
    }
    return Math.sqrt(sum);
}

/**
 * Returns the cosine similarity between two vectors
 *
 * https://en.wikipedia.org/wiki/Cosine_similarity
 */
export function cosine_similarity(a: number[], b: number[]): number {
    return dotProduct(a, b) / (magnitude(a) * magnitude(b));
}

/**
 * Converts an array into a string with customizable last join word.
 * @param array The array to convert into a string.
 * @param joinWord The string joining the items of the array.
 * @param lastJoinWord The string used to join the last two items in the array.
 * @returns
 */
export function joinArrayWithSpecialLastJoinWord<T>(
    array: T[],
    joinWord = ', ',
    lastJoinWord = ', or ',
) {
    return array.reduce((acc, cur, ind) => {
        if (ind > 0) {
            if (ind === array.length - 1) {
                acc += lastJoinWord;
            } else {
                acc += joinWord;
            }
        }
        acc += cur;
        return acc;
    }, '');
}
